"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIExactConnectionStatus = exports.IExactConnectionStatusTokenStateEnum = void 0;
/**
    * @export
    * @enum {string}
    */
var IExactConnectionStatusTokenStateEnum;
(function (IExactConnectionStatusTokenStateEnum) {
    IExactConnectionStatusTokenStateEnum["Valid"] = "valid";
    IExactConnectionStatusTokenStateEnum["Refreshable"] = "refreshable";
    IExactConnectionStatusTokenStateEnum["LoginRequired"] = "loginRequired";
    IExactConnectionStatusTokenStateEnum["Missing"] = "missing";
})(IExactConnectionStatusTokenStateEnum || (exports.IExactConnectionStatusTokenStateEnum = IExactConnectionStatusTokenStateEnum = {}));
function parseIExactConnectionStatus(data) {
    if (typeof data.lastTokenDate === 'string')
        data.lastTokenDate = new Date(data.lastTokenDate);
    return data;
}
exports.parseIExactConnectionStatus = parseIExactConnectionStatus;
